import axios from 'axios'
import baseURL from "@/apis/base"
import md5 from 'js-md5'

const install = axios.create({
    baseURL: baseURL.baseURL,
    timeout: 2000,
    headers: { 'Content-Type': "application/json" }
});

// 请求发送之前 ，， 未请求
install.interceptors.request.use(function (config) {

    // 判断请求类型 是post就将所有验证的东西放进header
    if (config.method == "post") {
        // 当前毫秒时间戳
        let timestamp = "";
        // 随机6为字符串
        let nonceStr = "";
        // appId
        let appId = "2022pipeline";
        // appSecret
        let appSecret = "wxs2tfd4diu88df9";
        // sign
        let sign = "";

        timestamp = parseInt(new Date().getTime());
        // 获取随机6位字符串  默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
        const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        let maxPos = chars.length;
        for (let i = 0; i < 6; i++) {
            nonceStr += chars.charAt(
                Math.floor(Math.random() * maxPos)
            );
        }

        sign = md5(`${timestamp}${appId}${nonceStr}${appSecret}`);

        config.headers["timestamp"] = timestamp;
        config.headers["sign"] = sign;
        config.headers["appId"] = appId;
        config.headers["nonceStr"] = nonceStr;
        config.headers["token"] = localStorage.getItem('token') || "";
        //config.headers["token"] = "Ykwt1VYIpfxIzs4oj373430PlFJir31i";

    }
    return config;
})



// 添加响应拦截器
// 请求发送之后 ，， 已请求，等待响应
install.interceptors.response.use(function (response) {

    // 对响应数据做点什么
    // response.status是检查前后端的连接出错没
    if (response.status < 300) {
        // 进来了说明连接没问题 ,code出错就检查是自己的参数是否正确，后端对这个接口的处理正确没
        if (response.data.code == 200) {
            // 请求响应成功 , 返回数据
            return Promise.resolve(response.data)
        } else {
            // 这里一般统一对参数问题进行处理(一般使用element的警告消息弹窗将 后端返回的  response.data.message 将错误信息同统一的处理)

        }
    } else {
        // 重置路由，请求异常
        // router.push(login) 回到主页 ，清除缓存数据，例如路由表
        return Promise.reject(response.data)
    }
}, function (error) {
    // 对响应错误做点什么
    // 一般统一报 网络错误
    return Promise.reject(error);
});

export default function request(params) {
    return install(params)
}